module.exports = __webpack_public_path__ + "images/2b5a7f8a9ceb83753c8a74cf55ba2098.png";